<template>
  <a-drawer :visible="visible" :width="1100" title="优惠券发放记录" @close="close" destroy-on-close>
    <!-- 检索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="优惠券标题">
              <a-input v-model="query.couponName" placeholder="请输入优惠券标题" allow-clear />
            </a-form-item>
          </a-col> -->
          <a-col :md="8" :sm="24">
            <a-form-item label="优惠券状态">
              <a-select v-model="query.status" placeholder="请选择状态" allow-clear>
                <a-select-option :value="0">失效</a-select-option>
                <a-select-option :value="1">有效</a-select-option>
                <a-select-option :value="2">使用过</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="10" :sm="24">
            <a-form-item label="领取时间">
              <a-range-picker
                v-model="dateRange"
                :show-time="{ format: 'HH:mm:ss' }"
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['开始时间', '结束时间']"
                style="width: 100%"
                @change="handleDateChange"
              />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24" style="text-align: right">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery">重置</a-button>
            </span>
          </a-col>
        </a-row>

      </a-form>
    </div>

    <!-- 表格 -->
    <a-table
      row-key="id"
      :loading="loading"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"

      @change="changeSize"
    >
      <span slot="reduceAmount" slot-scope="text, record">
        <span v-if="record.couponType === 10">减 ¥{{ text }}</span>
        <span v-else-if="record.couponType === 20">{{ (record.couponDiscount * 10).toFixed(1) }}折</span>
        <span v-else-if="record.couponType === 30">免单</span>
        <span v-else>-</span>
      </span>
      <span slot="status" slot-scope="text">
        {{ { 0: '失效', 1: '有效', 2: '使用过' }[text] || '-' }}
      </span>
      <span slot="receiveTime" slot-scope="text">{{ parseTime(text) }}</span>
    </a-table>
  </a-drawer>
</template>

<script>
import { getDistributeRecordList } from '@/api/coupon/controller/index.js'

export default {
  name: 'DistributeRecordDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      couponId: '',
      list: [],
      total: 0,
      dateRange: [],
      query: {
        pageNum: 1,
        pageSize: 10,
        couponId: '',
        collectTenantName: '',
        status: undefined,
        createBeginTime: '',
        createEndTime: '',
      },
      columns: [
        { title: '单位名称', dataIndex: 'collectTenantName', width: 180, align: 'center' },
        { title: '优惠券标题', dataIndex: 'couponName', width: 200, align: 'center', ellipsis: true },
        { title: '优惠内容', dataIndex: 'reduceAmount', width: 120, align: 'center', scopedSlots: { customRender: 'reduceAmount' } },
        { title: '优惠券状态', dataIndex: 'status', width: 120, align: 'center', scopedSlots: { customRender: 'status' } },
        { title: '领券时间', dataIndex: 'receiveTime', width: 160, align: 'center', scopedSlots: { customRender: 'receiveTime' } },
        { title: '有效期', width: 280, align: 'center', customRender: (text, record) => `${record.userStartTime || '-'} ~ ${record.userEndTime || '-'}` },
      ],
    }
  },
  computed: {
    pagination() {
      return {
        current: this.query.pageNum,
        pageSize: this.query.pageSize,
        total: this.total,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      }
    },
  },
  methods: {
    open(options = {}) {
      this.query = {
        pageNum: 1,
        pageSize: 10,
        couponId: options.id || '',
        collectTenantName: '',
        status: undefined,
        createBeginTime: '',
        createEndTime: '',
      }
      this.couponId = options.id || ''
      this.dateRange = []
      this.visible = true
      this.getList()
    },
    close() {
      this.visible = false
    },
    getList() {
      this.loading = true
      getDistributeRecordList(this.query)
        .then((res) => {
          this.list = res.data.records
          this.total = res.data.total
        })
        .finally(() => (this.loading = false))
    },
    handleQuery() {
      this.query.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.query = {
        pageNum: 1,
        pageSize: 10,
        couponId: this.couponId || '',
        collectTenantName: '',
        status: undefined,
        createBeginTime: '',
        createEndTime: '',
      }
      this.dateRange = []
      this.getList()
    },
    changeSize({ current, pageSize }) {
      this.query.pageNum = current
      this.query.pageSize = pageSize
      this.getList()
    },
    handleDateChange(dates) {
      if (dates && dates.length === 2) {
        this.query.createBeginTime = dates[0].format('YYYY-MM-DD') + ' 00:00:00'
        this.query.createEndTime = dates[1].format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        this.query.createBeginTime = ''
        this.query.createEndTime = ''
      }
    },
  },
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}
</style>
